import { SqueletteChangelog } from "@squeletteapp/widget-react";

import { squeletteKey } from "./squelette-key";

/**
 * What is new in the product, as a tile.
 *
 * A tile in the bottom right corner, and nothing until there is an
 * announcement this visitor has not seen, which is the case most of the time.
 * It slides away or closes on its cross, and the browser remembers it was
 * seen.
 *
 * Nothing to lay out in the sidebar: the widget places itself and moves
 * nothing in the application. Its colors come from the `--sq-*` tokens set on
 * `:root` in index.css.
 */
export default function ChangelogWidget() {
  if (!squeletteKey) return null;

  return <SqueletteChangelog apiKey={squeletteKey} theme="light" />;
}
